import { SocketsService } from './core/services/sockets.service'
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core'
import { Router, NavigationEnd } from '@angular/router'
import { AuthenticationService, UtilitiesService } from '@app/core/services'
import { User } from '@app/core/models'
import { ConnectionService } from 'ng-connection-service'
import { Subscription } from 'rxjs'

import * as moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City')
moment.locale('es-mx')

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'eCert';
  user: User;
  loading = false;
  initials = ''
  operadores = false;
  public photoUrl = ''
  solicitudes = false;
  usuarios = false
  revisiones = false
  inspecciones = false
  dictamenes = false
  expedientes = false
  catalogos = false
  cotizador = false
  certificados = false
  sustancias = false
  perfil = false
  no_conformidades = false
  certificadoExterno = true //Validacion para mostrar/ocultar barra superior, certificado externo
  emails = false
  supportUtilities = false
  reports = false
  regenerateNcs = false
  accompanyingDocument = false

  public innerWidth: any;

  // Check internet connection
  isOnline: boolean = false
  isSlow: boolean = false
  private subscription: Subscription

  // Maintenance status
  private intervalId: any
  private timeoutId: any
  closedMaintenanceMessage: boolean = false
  isActiveMaintenance: boolean = false
  startMaintenance: string = ''
  endMaintenance: string = ''

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private socketsService: SocketsService,
    private connectionService: ConnectionService,
    private utilitiesService: UtilitiesService,
  ) {
    this.authenticationService.user.subscribe((x) => {
      this.user = x
      this.initials = x?.firstName.substring(0, 1) + x?.middleName.substring(0, 1)

      this.photoUrl = x?.photoUrl
      //console.log(x)
    });
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        //console.log(e.url);
        if (e.url.startsWith('/operadores')) { this.operadores = true } else { this.operadores = false }
        if (e.url.startsWith('/solicitudes')) { this.solicitudes = true } else { this.solicitudes = false }
        if (e.url.startsWith('/usuarios')) {
          if (this.user.type == 'ADMINISTRADOR_SISTEMA' || this.user.type == 'ROOT') {
            this.usuarios = true
          }
        } else { this.usuarios = false }
        if (e.url.startsWith('/revisiones')) { this.revisiones = true } else { this.revisiones = false }
        if (e.url.startsWith('/inspecciones')) { this.inspecciones = true } else { this.inspecciones = false }
        if (e.url.startsWith('/dictamenes')) { this.dictamenes = true } else { this.dictamenes = false }
        if (e.url.startsWith('/expedientes')) { this.expedientes = true } else { this.expedientes = false }
        if (e.url.startsWith('/catalogos')) { this.catalogos = true } else { this.catalogos = false }
        if (e.url.startsWith('/cotizador')) { this.cotizador = true } else { this.cotizador = false }
        if (e.url.startsWith('/certificados')) { this.certificados = true } else { this.certificados = false }
        if (e.url.startsWith('/sustancias')) { this.sustancias = true } else { this.sustancias = false }
        if (e.url.startsWith('/perfil')) { this.perfil = true } else { this.perfil = false }
        if (e.url.startsWith('/no_conformidades')) { this.no_conformidades = true } else { this.no_conformidades = false }
        if (e.url.startsWith('/certificado_consulta')) { this.certificadoExterno = false } else { this.certificadoExterno = true } //Ruta del certificado externo
        if (e.url.startsWith('/emails')) { this.emails = true } else { this.emails = false }
        if (e.url.startsWith('/support_utilities')) { this.supportUtilities = true } else { this.supportUtilities = false }
        if (e.url.startsWith('/reportes')) { this.reports = true } else { this.reports = false }
        if (e.url.startsWith('/regenerar_ncs')) { this.regenerateNcs = true } else { this.regenerateNcs = false }
        if (e.url.startsWith('/documento_acompanamiento')) { this.accompanyingDocument = true } else { this.accompanyingDocument = false }
      }
    });
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    //this.socketsService.setupSocketConnection()

    this.checkInternetConnection()

    this.checkMaintenance()
  }

  ngOnDestroy(): void {
    // Unsubscribe from any subscriptions
    this.subscription.unsubscribe()

    // Clear interval timers if they exist
    if(this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }

    // Clear timeout timers if they exist
    if(this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  private clearMaintenanceStorage() {
    // Remove maintenance alert flags from sessionStorage and localStorage
    sessionStorage.removeItem('maintenanceClose');
    localStorage.removeItem('maintenanceClose');
  }

  checkInternetConnection() {
    // Check status of network (ONLINE or OFFLINE)
    this.subscription = this.connectionService.monitor()
      .subscribe(
        isConnected => {
          this.isOnline = isConnected
        }
      )

    // Estado inicial inmediato
    this.isOnline = navigator.onLine;
    this.checkNetworkSpeed();
  }

  checkNetworkSpeed() {
    if('connection' in navigator) {
      const connection = (navigator as any).connection
      const updateNetworkType = () => {
        this.isSlow = ['slow-2g','2g','3g'].includes(connection.effectiveType)
      }
      connection.addEventListener('change', updateNetworkType)
      updateNetworkType()
    }
  }

  checkMaintenance() {
    const keepClosedMaintenanceAlertSS = sessionStorage.getItem('maintenanceClose')
    const keepClosedMaintenanceAlertLS = localStorage.getItem('maintenanceClose')

    const maintenanceClosed = keepClosedMaintenanceAlertSS === 'true' || keepClosedMaintenanceAlertLS === 'true'

    if(maintenanceClosed) {
      sessionStorage.setItem('maintenanceClose', 'true')
      localStorage.setItem('maintenanceClose', 'true')
      this.closedMaintenanceMessage = true
      return
    } 
    
    // Check immediately maintenance
    this.checkSynchronizedMaintenance()

    // time to check status maintenance in minutes, 2hrs = 2hrs * 60min = 120min
    const timeToCheckInMinutes = 120

    // Calculate time to next check maintenance
    const now = moment()
    const nextHour = now.clone().add(timeToCheckInMinutes, 'minute').startOf('minute')
    const delay = nextHour.diff(now)

    this.timeoutId = setTimeout(() => {
      this.checkSynchronizedMaintenance()

      this.intervalId = setInterval(() => {
        this.checkSynchronizedMaintenance()
      }, (timeToCheckInMinutes * 60000)) // In milliseconds, 1min = 60seg * 1000ms = 60000ms
    }, delay)
  }

  checkSynchronizedMaintenance() {
    this.utilitiesService.getMaintenance()
      .subscribe(
        response => {
          if(!!response.data) {
            this.isActiveMaintenance = response.data.is_active

            if(this.isActiveMaintenance) {
              this.startMaintenance = moment.tz(
                  response.data.start_date_time,
                  'YYYY/MM/DD HH:mm',
                  'America/Mexico_City'
              ).format('DD [de] MMMM [de] YYYY [a las] HH:mm [horas]')

              this.endMaintenance = moment.tz(
                  response.data.end_date_time,
                  'YYYY/MM/DD HH:mm',
                  'America/Mexico_City'
              ).format('DD [de] MMMM [de] YYYY [a las] HH:mm [horas]')
            } else {
              this.closedMaintenanceMessage = false
              this.isActiveMaintenance = false
              this.startMaintenance = ''
              this.endMaintenance = ''

              sessionStorage.removeItem('maintenanceClose')
              localStorage.removeItem('maintenanceClose')
            }
          } else {
            this.closedMaintenanceMessage = false
            this.isActiveMaintenance = false
            this.startMaintenance = ''
            this.endMaintenance = ''

            sessionStorage.removeItem('maintenanceClose')
            localStorage.removeItem('maintenanceClose')
          }
        },
        error => {
          console.error("Error getting maintenance status: ", error)
        }
      )
  }

  closeMaintenanceAlert() {
    this.closedMaintenanceMessage = true
    this.isActiveMaintenance = false
    sessionStorage.setItem('maintenanceClose', 'true')
    localStorage.setItem('maintenanceClose', 'true')
  }

  //If you wanna keep it updated on resize
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  logout() {
    // Also clear storage if the component is destroyed during internal route changes
    this.clearMaintenanceStorage();

    this.authenticationService.logout();
  }
}